import { createFileRoute } from "@tanstack/react-router";
import Link from "~/components/Link";
import { NewStudentButton } from "~/components/CreateButtons";
import { PageLoading } from "~/components/PageLoading";
import { WithStudentNav } from "~/components/WithStudentNav";
import { trpc } from "~/utils/trpc.client";

export const Route = createFileRoute("/_authed/$teamId/students/")({
  component: StudentsPage,
});

function StudentsPage() {
  const { teamId } = Route.useParams();
  const studentsQuery = trpc.students.getStudents.useQuery({ teamId });

  return (
    <WithStudentNav>
      <div className="relative m-auto flex h-full w-full max-w-xl flex-col gap-4 p-4">
        {/* Students */}
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">Students</h1>
          <NewStudentButton teamId={teamId} className="btn btn-primary btn-sm">
            New Student
          </NewStudentButton>
        </div>
        {!studentsQuery.data ? (
          <PageLoading />
        ) : (
          <div className="flex">
            {studentsQuery.data.length === 0 ? (
              <div className="flex h-full w-full place-content-center place-items-center italic opacity-70">
                No students found
              </div>
            ) : (
              <div className="flex flex-col gap-4 w-full">
                {studentsQuery.data.map((student) => (
                  <Link
                    key={student.id}
                    className="card bg-base-100 link no-underline shadow"
                    href={`/${teamId}/students/${student.id}`}
                  >
                    <div className="card-body p-6">
                      <div className="flex items-center">
                        <div className="avatar avatar-placeholder w-10">
                          <div className="text-primary-content w-24 rounded-full bg-sky-600">
                            <span className="">
                              {student.name
                                .split(" ")
                                .map((name) => name[0])
                                .join("")
                                .toUpperCase()}
                            </span>
                          </div>
                        </div>
                        <div className="ml-3">
                          <h2 className="">{student.name}</h2>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </WithStudentNav>
  );
}
